import { render, staticRenderFns } from "./VoucherPitch.vue?vue&type=template&id=03b81d52"
import script from "./VoucherPitch.vue?vue&type=script&lang=js"
export * from "./VoucherPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports